import Crop from './src/crop';
export default Crop;